<script setup>
import { ROUTES } from '@/router/routeNames'
const props = defineProps({
  type: {
    type: String,
    default: 'submit',
  },
  loading: {
    type: Boolean,
    default: false,
  },
  to: {
    type: Object,
    default: () => {
      name: ROUTES.HOME
    },
  },
  as: {
    type: String,
    default: 'button',
    validator: (value) => ['button', 'link'].includes(value),
  },
  size: {
    type: String,
    default: 'default',
    validator: (value) => ['small', 'default', 'large'].includes(value),
  },
})

const baseClasses =
  'font-semibold transition duration-300 transform rounded-full shadow-lg hover:shadow-xl hover:-translate-y-1'

const sizeClasses = {
  small: 'px-4 py-2 text-sm',
  default: 'px-8 py-3',
  large: 'px-10 py-4 text-lg',
}

const typeClasses = {
  primary: 'text-green-600 bg-white border-2 border-transparent hover:bg-green-50',
  secondary: 'bg-transparent border-2 border-white text-white hover:bg-white hover:text-green-600',
  submit:
    'text-white bg-green-600 hover:bg-green-700 focus:ring-green-500 focus:ring-offset-green-50 focus:ring-offset-2',
}

const classes = `${baseClasses} ${sizeClasses[props.size]} ${typeClasses[props.type]}`
</script>

<template>
  <RouterLink v-if="as === 'link'" :to="to" :class="classes">
    <slot></slot>
  </RouterLink>
  <button v-else type="type === 'submit' ? 'submit' : 'button'" :class="classes">
    <slot></slot>
  </button>
</template>
